
import React, { useState } from 'react';
import { InputContainer } from '../../../../../../../common/components/form/input/containers/input.container';
import TabContainer from '../../../../../../../common/components/tab/containers/tab.containers';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import SmsRecipientInfoComponent from './sms-recipient-info.component';

export const SmsMarketingPlanComponent = ({
  campaignFrequency,
  customerTags,
  choosenSmsPlan,
  handleInnerFormChange,
  closeModal,
  handleSubmit
}: any) => {
  

  const [selectedSmsPlan, setSelectedSmsPlan]=useState<any>(choosenSmsPlan);

  const close =() => {
    closeModal();
  }
  const tabItems=[
    {
        id:1,
        title:'Recipient',
        component:   <SmsRecipientInfoComponent
        choosenSmsPlan={selectedSmsPlan}
        handleInnerFormChange={handleInnerFormChange}
        customerTags={customerTags}
        isEmail
      />,
    isVisible:true ,
    },
//     {
//       id:2,
//       title:'Budget',
//       component: <PlanBudgetInfoComponent
//       planBudget={emailBudget}
//       handleInnerFormChange={handleInnerFormChange}
//     />,
//     isVisible:true,
//   },
//   {
//     id:3,
//     title:'Notes',
//     component: <PlanSmsInfoComponent
//     planNotes={emailNotes}
//     handleInnerFormChange={handleInnerFormChange}
    
//   />,
//   isVisible:true,
// }
,]

const onSubmit = (e: any) => {
  choosenSmsPlan = selectedSmsPlan
  handleSubmit(e)
}
  
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-2 gap-4'>
              <InputContainer
                label="Name"
                labelField="Name"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'Name');
                }}
                type="text"
                value={choosenSmsPlan?.Name}
              />
         
              <InputContainer
                label="Campaign Frequency"
                labelField="Text"
                list={campaignFrequency}
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'FrequencyId');
                }}
                optionName='Choose Campaign Frequency '
                type="select"
                value={choosenSmsPlan?.FrequencyId}
                valueField="Value"
              />
           
              <InputContainer
                isDateTimePicker
                label="Start Date"
                name="StartDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'StartDate');
                }}
                type="date"
                value={choosenSmsPlan?.StartDate}
              />
           
              <InputContainer
                isDateTimePicker
                label="End Date"
                name="EndDate"
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'EndDate');
                }}
                type="date"
                value={choosenSmsPlan?.EndDate}
              />
            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />

      <AccordionContainer
        child={
          <TabContainer tabItems={tabItems} />
        }
        expandedPanel="Email Receipient Info"
        headerTitle="Email Receipient Info"
      />
      <div className="text-end">
          <button
            onClick={close}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            >
            Close
            </button>
            <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={(e)=>onSubmit(e)}
          
            type="submit"
        >
          Save
        </button>
          </div>
    </>
  );
};
export default SmsMarketingPlanComponent;
